var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.024,
    height: 37.024,
    rx: 10.68,
    fill: "#916145"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4366 19.2688L22.931 16.0475H19.84V13.957C19.84 13.0757 20.2718 12.2166 21.6562 12.2166H23.0614V9.47398C23.0614 9.47398 21.7862 9.25635 20.5669 9.25635C18.0214 9.25635 16.3575 10.7992 16.3575 13.5923V16.0475H13.528V19.2688H16.3575V27.0563H19.84V19.2688H22.4366Z",
    fill: "#F2F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.359520079cd4dc313e531b54d85b98ce.svg";
export { ForwardRef as ReactComponent };